export const translations = {
    PL: {
        "COMPANY": "Firma",
        "STAND_TYPE": "Stoisko",
        "STAND": "Stoisko",
        "SUBMIT": "Zatwierdz",
        "DISAGREE": "Odrzuć",
        "ARE_YOU_SURE": "Uwaga!",
        "STAND_SELECTION": "Wybór stoiska",
        "INFO": "Proszę wybrać jedno z dostępnych stoisk i zatwierdzić wybór.",
        "AFTER_SUBMIT_INFO": "Po zatwierdzeniu, nie ma możliwości zmiany wybranego stoiska.",
        "PSS_AREA": "Strefa PSS",
        "ENTRANCE": 'Wejście',
        "CONTACT": "Kontakt",
        "CHANGE_INFO": "Wybrałeś już stoisko, w razie pomyłki zmiana możliwa jedynie przez kontakt email (itp@best.krakow.pl)."
    },
    EN: {
        "COMPANY": "Company",
        "STAND_TYPE": "Stand",
        "STAND": "Stand",
        "SUBMIT": "Submit",
        "DISAGREE": "Disagree",
        "ARE_YOU_SURE": "Are you sure?",
        "STAND_SELECTION": "Stand selection",
        "INFO": "Please choose one of available stand and save results.",
        "AFTER_SUBMIT_INFO": "After submitting, there is not option to change stand!",
        "PSS_AREA": "PSS Area",
        "ENTRANCE": 'Entrance',
        "CONTACT": "Contact",
        "CHANGE_INFO": "Wybrałeś już stoisko, w razie pomyłki zmiana możliwa jedynie przez kontakt email (itp@best.krakow.pl)."
    }
};
